/**
 * Google Maps integration with ACF
 * 
 * @param {} map 
 */
const centerMap = (map) => {
    var bounds = new google.maps.LatLngBounds()

    // loop through all markers and create bounds
    map.markers.forEach((marker) => {
        var latlng = new google.maps.LatLng(
            marker.position.lat(),
            marker.position.lng()
        )
        bounds.extend(latlng)
    })

    // only 1 marker?
    if (map.markers.length == 1) {
        // set center of map
        map.setCenter(bounds.getCenter())
        map.setZoom(16)
    } else {
        // fit to bounds
        map.setCenter(bounds.getCenter())
        map.setZoom(11)
        map.fitBounds(bounds)
    }
}

const addMarker = (marker, map) => {
    var latlng = new google.maps.LatLng(
        marker.getAttribute('data-lat'),
        marker.getAttribute('data-lng')
    )

    var markerIcon = {
        url: markerImgGlobal,
        scaledSize: new google.maps.Size(44, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(22, 60)
    }

    // create marker
    var marker = new google.maps.Marker({
        position: latlng,
        icon: markerIcon,
        map: map
    })

    // add to array
    map.markers.push(marker)

    // if marker contains HTML, add it to an infoWindow
    if (marker.innerHTML) {
        // create info window
        infowindow = new google.maps.InfoWindow({
            content: marker.innerHTML
        })

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.setContent(marker.innerHTML)
            infowindow.open(map, marker)

            google.maps.event.addListener(map, 'click', function (event) {
                infowindow.close()
            })
        })
    }
}

const newMap = (element) => {
    var markers = element.querySelectorAll('.marker')
    var args = {
        zoom: 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        scaleControl: false,
        streetViewControl: false,
        styles: mapStyleGlobal
    }

    // create map
    var map = new google.maps.Map(element, args)

    // add a markers reference
    map.markers = []

    // add markers
    markers.forEach(function (marker) {
        addMarker(marker, map)
    })

    // center map
    centerMap(map)
    return map
}

const initGoogleMaps = () => {
    let maps = document.querySelectorAll('.acf-map')
    maps.forEach((mapElement) => {
        newMap(mapElement)
    })
}

export default initGoogleMaps